import React from 'react';
import { func, string } from 'prop-types';
import { UTButton, UTLabel } from '@widergy/energy-ui';
import Error from '@material-ui/icons/Error';

import { message } from 'utils/stringUtils';

import styles from './styles.module.scss';

const AccountsError = ({ onReload, errorMessage }) => (
  <div className={styles.container}>
    <div className={styles.messageContainer}>
      <Error className={styles.icon} />
      <UTLabel large darkGray>
        {errorMessage}
      </UTLabel>
    </div>
    <UTButton onPress={onReload} className={styles.button} uppercase>
      {message('Commons:reload')}
    </UTButton>
  </div>
);

AccountsError.propTypes = {
  onReload: func,
  errorMessage: string
};

export default AccountsError;
